// extracted by mini-css-extract-plugin
module.exports = {"container":"Experience_container__2im1P","inputWrap":"Experience_inputWrap__2W0Jg","name":"Experience_name__T_pRL","btns":"Experience_btns__mwdTk"};